'use strict';

import angular from 'angular';

/**
 * Service pour gérer les données des contrats pétroliers
 */
export default angular.module('observatoireApp')
  .service('ContratsService', ['$http', '$q', function($http, $q) {
    // Données mockées pour la démonstration
    const contratsData = [
      {
        id: 1,
        denomination: 'Consortium : Esso - Petronas Carigali - Chevron Ltd',
        nif: '600002755; 9001705V et 9001629Z',
        reference: 'Convention Esso 2004',
        matiereContractee: 'Pétrole et gaz',
        typeContrat: 'Contrat de concession (Convention)',
        status: 'Contrat de concession en cours',
        lienReference: 'https://bit.ly/3RVYbEm',
        dateSignature: '2004-05-10',
        // Nouveaux champs
        projet: 'Projet 1',
        dateFinPrevue: null, // Non disponible
        dateFinProrogee: null, // Non disponible
        dateResiliation: null, // Non disponible
        dateDerniereModification: null, // Non disponible
        province: null, // Non disponible
        departement: null, // Non disponible
        commentaires: null, // Non disponible
        participants: [
          { nom: 'ESSO', pourcentage: 40 },
          { nom: 'PETRONAS', pourcentage: 35 },
          { nom: 'SHTPCCL', pourcentage: 25 }
        ],
        documents: [
          { type: 'Contrat', nom: 'CONVENTION ESSO 2004', url: 'https://bit.ly/3RVYbEm' }
        ],
        avenants: [
          { nom: 'AVENANT N° 1', date: '2006-03-15', url: 'https://bit.ly/avenant1' }
        ],
        
        // Anciennes données conservées pour compatibilité
        numero: 'CPP-2025-001',
        titre: 'Contrat de Partage de Production du Bloc Sedigui',
        date: '2023-04-18',
        annee: 2023,
        entreprise: 'PetroCorp International',
        bloc: 'Sedigui',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2023-05-01',
        dateFin: '2033-05-01',
        superficie: 1250,
        investissementPrevu: 450000000
      },
      {
        id: 2,
        denomination: 'TotalEnergies EP Tchad',
        nif: 'TC87654321',
        reference: 'CPP-2024-003',
        matiereContractee: 'Exploration et production pétrolière',
        typeContrat: 'Partage de Production',
        status: 'En vigueur',
        lienReference: 'https://www.observatoire.td/documents/cpp-2024-003.pdf',
        dateSignature: '2024-07-12',
        // Anciennes données conservées pour compatibilité
        numero: 'CPP-2024-003',
        titre: 'Contrat de Partage de Production du Bloc Doba',
        date: '2024-07-12',
        annee: 2024,
        entreprise: 'TotalEnergies EP Tchad',
        bloc: 'Doba',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2024-09-01',
        dateFin: '2044-09-01',
        superficie: 2150,
        investissementPrevu: 780000000
      },
      {
        id: 3,
        denomination: 'CNPCIC',
        nif: 'TC97531025',
        reference: 'CPP-2022-007',
        matiereContractee: 'Exploration et production pétrolière',
        typeContrat: 'Partage de Production',
        status: 'En vigueur',
        lienReference: 'https://www.observatoire.td/documents/cpp-2022-007.pdf',
        dateSignature: '2022-11-30',
        // Anciennes données
        numero: 'CPP-2022-007',
        titre: 'Contrat de Partage de Production du Bloc Lac Tchad',
        date: '2022-11-30',
        annee: 2022,
        entreprise: 'CNPCIC',
        bloc: 'Lac Tchad',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2023-01-15',
        dateFin: '2043-01-15',
        superficie: 3050,
        investissementPrevu: 650000000
      },
      {
        id: 4,
        denomination: 'Glencore E&P',
        nif: 'TC36925814',
        reference: 'CPP-2023-004',
        matiereContractee: 'Exploration et extraction pétrolière',
        typeContrat: 'Partage de Production',
        status: 'En vigueur',
        lienReference: 'https://www.observatoire.td/documents/cpp-2023-004.pdf',
        dateSignature: '2023-09-05',
        // Anciennes données
        numero: 'CPP-2023-004',
        titre: 'Contrat de Partage de Production du Bloc Bongor',
        date: '2023-09-05',
        annee: 2023,
        entreprise: 'Glencore E&P',
        bloc: 'Bongor',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2023-11-01',
        dateFin: '2043-11-01',
        superficie: 1850,
        investissementPrevu: 520000000
      },
      {
        id: 5,
        denomination: 'ExxonMobil Chad',
        nif: 'TC45678912',
        reference: 'CPP-2024-002',
        matiereContractee: 'Production et raffinage',
        typeContrat: 'Partage de Production',
        status: 'En vigueur',
        lienReference: 'https://www.observatoire.td/documents/cpp-2024-002.pdf',
        dateSignature: '2024-03-22',
        // Anciennes données
        numero: 'CPP-2024-002',
        titre: 'Contrat de Partage de Production du Bloc Chari Ouest',
        date: '2024-03-22',
        annee: 2024,
        entreprise: 'ExxonMobil Chad',
        bloc: 'Chari Ouest',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2024-06-01',
        dateFin: '2044-06-01',
        superficie: 2340,
        investissementPrevu: 830000000
      },
      {
        id: 6,
        numero: 'CPP-2022-005',
        titre: 'Contrat de Partage de Production du Bloc Doseo',
        date: '2022-05-17',
        annee: 2022,
        entreprise: 'Sahara Energy Resources',
        bloc: 'Doseo',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2022-07-01',
        dateFin: '2042-07-01',
        superficie: 1620,
        investissementPrevu: 380000000
      },
      {
        id: 7,
        numero: 'CPP-2024-001',
        titre: 'Contrat de Partage de Production du Bloc Kanem',
        date: '2024-01-08',
        annee: 2024,
        entreprise: 'ONGC Videsh Ltd',
        bloc: 'Kanem',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2024-04-01',
        dateFin: '2044-04-01',
        superficie: 2780,
        investissementPrevu: 610000000
      },
      {
        id: 8,
        numero: 'CPP-2023-002',
        titre: 'Contrat de Partage de Production du Bloc Salamat',
        date: '2023-06-29',
        annee: 2023,
        entreprise: 'Petronas Carigali Chad',
        bloc: 'Salamat',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2023-08-15',
        dateFin: '2043-08-15',
        superficie: 1940,
        investissementPrevu: 490000000
      },
      {
        id: 9,
        numero: 'CPP-2022-001',
        titre: 'Contrat de Partage de Production du Bloc Erdis',
        date: '2022-02-14',
        annee: 2022,
        entreprise: 'United Hydrocarbon Chad',
        bloc: 'Erdis',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2022-04-01',
        dateFin: '2042-04-01',
        superficie: 3210,
        investissementPrevu: 720000000
      },
      {
        id: 10,
        numero: 'CPP-2023-007',
        titre: 'Contrat de Partage de Production du Bloc Mayo-Kebbi',
        date: '2023-12-05',
        annee: 2023,
        entreprise: 'Chevron Chad',
        bloc: 'Mayo-Kebbi',
        type: 'Partage de Production',
        statut: 'En vigueur',
        dateDebut: '2024-02-01',
        dateFin: '2044-02-01',
        superficie: 2100,
        investissementPrevu: 580000000
      }
    ];

    // Détails additionnels pour chaque contrat
    const detailsContrats = {
      1: {
        parties: [
          { nom: 'République du Tchad', role: 'État hôte' },
          { nom: 'PetroCorp International', role: 'Contractant' }
        ],
        clauses: [
          { titre: 'Durée', description: 'Contrat d\'une durée initiale de 10 ans avec possibilité de prolongation de 5 ans.' },
          { titre: 'Redevance', description: 'Redevance de 12.5% sur la production brute.' },
          { titre: 'Cost Oil', description: 'Limite fixée à 60% de la production disponible.' },
          { titre: 'Profit Oil', description: 'Partage selon une échelle mobile basée sur le facteur R, variant de 40% à 60% pour l\'État tchadien.' }
        ],
        documents: [
          { nom: 'Contrat principal', format: 'PDF', taille: '2.4 MB', date: '2023-04-18' },
          { nom: 'Annexe technique', format: 'PDF', taille: '1.8 MB', date: '2023-04-18' },
          { nom: 'Plan de développement', format: 'PDF', taille: '3.2 MB', date: '2023-06-15' }
        ],
        avenants: [
          { numero: 'Avenant N°1', date: '2024-02-10', objet: 'Extension de la zone contractuelle' }
        ],
        historique: [
          { date: '2023-04-18', evenement: 'Signature du contrat' },
          { date: '2023-05-01', evenement: 'Entrée en vigueur' },
          { date: '2023-07-15', evenement: 'Approbation du plan de développement' },
          { date: '2024-02-10', evenement: 'Signature de l\'avenant N°1' }
        ]
      }
    };

    // Générer des détails pour tous les contrats
    for (let i = 2; i <= 10; i++) {
      detailsContrats[i] = {
        parties: [
          { nom: 'République du Tchad', role: 'État hôte' },
          { nom: contratsData.find(c => c.id === i).entreprise, role: 'Contractant' }
        ],
        clauses: [
          { titre: 'Durée', description: 'Contrat d\'une durée initiale de 20 ans avec possibilité de prolongation.' },
          { titre: 'Redevance', description: 'Redevance de 14.5% sur la production brute.' },
          { titre: 'Cost Oil', description: 'Limite fixée à 55% de la production disponible.' },
          { titre: 'Profit Oil', description: 'Partage selon une échelle mobile basée sur le facteur R, variant de 45% à 65% pour l\'État tchadien.' }
        ],
        documents: [
          { nom: 'Contrat principal', format: 'PDF', taille: '2.8 MB', date: contratsData.find(c => c.id === i).date },
          { nom: 'Annexe technique', format: 'PDF', taille: '1.6 MB', date: contratsData.find(c => c.id === i).date }
        ],
        avenants: [],
        historique: [
          { date: contratsData.find(c => c.id === i).date, evenement: 'Signature du contrat' },
          { date: contratsData.find(c => c.id === i).dateDebut, evenement: 'Entrée en vigueur' }
        ]
      };
    }

    /**
     * Récupère les détails d'un contrat spécifique
     * @param {number} id Identifiant du contrat
     * @returns {Promise} Promesse contenant les détails du contrat
     */
    this.getContratDetails = function(id) {
      const deferred = $q.defer();
      
      $http.get('/api/contrats-petroliers/' + id)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(error) {
          console.error('Erreur API détails contrat:', error);
          if (detailsContrats[id]) {
            deferred.resolve(detailsContrats[id]);
          } else {
            deferred.reject('Détails du contrat non trouvés');
          }
        });
      
      return deferred.promise;
    };

    /**
     * Télécharge un contrat au format spécifié
     * @param {number} id Identifiant du contrat
     * @param {string} format Format du document (pdf, doc)
     * @returns {Promise} Promesse contenant les données du document
     */
    this.telechargerContrat = function(id, format) {
      // Dans un environnement réel, ceci ferait un appel API pour récupérer le document
      // Ici, nous simulons simplement la réponse
      
      const deferred = $q.defer();
      
      setTimeout(function() {
        // Simuler une réponse HTTP
        deferred.resolve({
          data: 'Document simulé',
          headers: function(name) {
            if (name === 'Content-Type') {
              return format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            }
            return '';
          }
        });
      }, 1000);
      
      return deferred.promise;
    };

    /**
     * Exporte les données des contrats au format Excel (XLSX)
     * @param {Array} contrats Liste des contrats à exporter
     * @returns {Promise} Promesse indiquant le succès de l'export
     */
    this.exporterContrats = function(contrats) {
      const deferred = $q.defer();
      
      // Importer dynamiquement l'utilitaire d'export
      import('../utils/excel-export.js')
        .then(function(excelExportModule) {
          const excelExport = excelExportModule.default;
          try {
            // Nettoyer et formater les données pour l'export
            const preparedData = excelExport.prepareDataForExport(contrats);
            
            // Exporter les données et déclencher le téléchargement (async)
            excelExport.exportToExcel(preparedData, 'contrats_petroliers.xlsx')
              .then(function() {
                deferred.resolve({
                  success: true,
                  message: 'Export Excel réalisé avec succès'
                });
              })
              .catch(function(err) {
                console.error('Erreur lors de la génération du fichier Excel:', err);
                deferred.reject('Erreur lors de l\'export Excel. Veuillez réessayer.');
              });
          } catch (err) {
            console.error('Erreur lors de l\'export Excel:', err);
            deferred.reject('Erreur lors de l\'export Excel. Veuillez réessayer.');
          }
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement du module d\'export:', error);
          deferred.reject('Erreur lors de l\'export Excel. Veuillez réessayer.');
        });
      
      return deferred.promise;
    };
    /**
     * Récupère la liste des contrats pétroliers depuis l'API backend
     * @returns {Promise} Promesse contenant les données des contrats
     */
    this.getContrats = function() {
      // Appel à l'API backend au lieu d'utiliser les données mockées
      const deferred = $q.defer();
      
      $http.get('/api/contrats-petroliers')
        .then(function(response) {
          console.log('Contrats récupérés depuis API:', response.data);
          deferred.resolve(response.data);
        })
        .catch(function(error) {
          console.error('Erreur lors de la récupération des contrats:', error);
          // Fallback sur les données mockées en cas d'erreur
          console.log('Utilisation des données mockées en secours');
          deferred.resolve(contratsData);
        });
      
      return deferred.promise;
    };
  }]);
